import React from "react";
import { Image, Carousel } from "react-bootstrap";
let listOfImages = [];

class TACarousel extends React.Component {
  importAll = requireModules => {
    return requireModules.keys().map(requireModules);
  };
  componentWillMount = () => {
    listOfImages = this.importAll(
      require.context(
        "../../images/onboardCarouselImages",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );
  };
  render() {
    return (
      <Carousel className="login-carousel" variant="dark" interval={2000}>
        {listOfImages.map((file, i) => (
          <Carousel.Item key={i}>
            <Image
              className="login-carousel-img d-block img-responsive w-100"
              src={file}
              alt={file}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }
}
export default TACarousel;
